import { Airport, AirportOwnershipType, AirportStatus, AirportType } from '../../airport/models/airport.model';
import { LandingSurfaceType } from '../../airport/models/landing-surface.model';
import { AirportSearchResult } from '../../airport/models/airport-search-result.model';
var AirportIconsComponent = /** @class */ (function () {
    function AirportIconsComponent() {
        this.compact = false;
    }
    Object.defineProperty(AirportIconsComponent.prototype, "closed", {
        /**
         * Returns true if the closed badge should be displayed.
         */
        get: function () {
            return this.airport.status === AirportStatus.ClosedIndefinitely
                || this.airport.status === AirportStatus.ClosedPermanently;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AirportIconsComponent.prototype, "closedLabel", {
        /**
         * Returns the label that should be displayed on the closed badge.
         */
        get: function () {
            return Airport.formatAirportStatus(this.airport.status);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AirportIconsComponent.prototype, "civil", {
        /**
         * Returns true if the civil badge should be displayed.
         */
        get: function () {
            return this.airport.airportOwnership === AirportOwnershipType.Civil;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AirportIconsComponent.prototype, "privateOwn", {
        /**
         * Returns true if the privately-owned badge should be displayed.
         */
        get: function () {
            return this.airport.airportOwnership === AirportOwnershipType.Private;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AirportIconsComponent.prototype, "military", {
        /**
         * Returns true if the military badge should be displayed.
         */
        get: function () {
            return this.airport.militaryJoint
                || this.airport.airportOwnership === AirportOwnershipType.Army
                || this.airport.airportOwnership === AirportOwnershipType.Navy
                || this.airport.airportOwnership === AirportOwnershipType.USAF
                || this.airport.airportOwnership === AirportOwnershipType.CoastGuard;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AirportIconsComponent.prototype, "militaryLabel", {
        /**
         * Returns the label to use on the military badge.
         * @returns {string}
         */
        get: function () {
            var type = '';
            if (this.airport.airportOwnership === AirportOwnershipType.Army
                || this.airport.airportOwnership === AirportOwnershipType.Navy
                || this.airport.airportOwnership === AirportOwnershipType.USAF
                || this.airport.airportOwnership === AirportOwnershipType.CoastGuard) {
                type = Airport.formatAirportOwnershipType(this.airport.airportOwnership);
                if (this.airport.militaryJoint) {
                    type = 'Civilian/' + type;
                }
            }
            var label = this.airport.militaryJoint ? 'Joint Use' : 'Military';
            if (type) {
                label += ' (' + type + ')';
            }
            return label;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AirportIconsComponent.prototype, "privateUse", {
        /**
         * Returns true if the private use badge should be shown.
         */
        get: function () {
            if (this.military) {
                return false;
            }
            return this.airport.publicUse !== null && !this.airport.publicUse;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AirportIconsComponent.prototype, "publicUse", {
        /**
         * Returns true if the public use badge should be shown.
         */
        get: function () {
            return this.airport.publicUse;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AirportIconsComponent.prototype, "unpaved", {
        /**
         * Returns true if the unpaved badge should be shown.
         */
        get: function () {
            if (this.airport instanceof AirportSearchResult) {
                return !this.airport.paved;
            }
            if (this.airport instanceof Airport) {
                return (this.airport.hasLandingSurfaceType(LandingSurfaceType.Runway)
                    || this.airport.hasLandingSurfaceType(LandingSurfaceType.Helipad))
                    && this.airport.landingSurfaces.every(function (sfc) { return !sfc.paved; });
            }
            return false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AirportIconsComponent.prototype, "heliport", {
        /**
         * Returns true if the heliport badge should be shown.
         */
        get: function () {
            return this.airport.type === AirportType.Heliport;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AirportIconsComponent.prototype, "seaport", {
        /**
         * Returns true if the seaplane base badge should be shown.
         */
        get: function () {
            return this.airport.type === AirportType.SeaplaneBase;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AirportIconsComponent.prototype, "ultralight", {
        /**
         * Returns true if the ultralight badge should be shown.
         */
        get: function () {
            return this.airport.type === AirportType.Ultralight;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AirportIconsComponent.prototype, "gliderport", {
        /**
         * Returns true if the gliderport badge should be shown.
         */
        get: function () {
            return this.airport.type === AirportType.GliderPort;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AirportIconsComponent.prototype, "balloonport", {
        /**
         * Returns true if the balloonport badge should be shown.
         */
        get: function () {
            return this.airport.type === AirportType.BalloonPort;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AirportIconsComponent.prototype, "aoe", {
        /**
         * Returns true if the airport of entry badge should be shown.
         */
        get: function () {
            return this.airport.customsIntlEntry;
        },
        enumerable: true,
        configurable: true
    });
    return AirportIconsComponent;
}());
export { AirportIconsComponent };
